import { render, staticRenderFns } from "./TotalConclusion.vue?vue&type=template&id=1a827f61&"
import script from "./TotalConclusion.vue?vue&type=script&lang=js&"
export * from "./TotalConclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports